import { Common } from '~/models/common';

export namespace ReviewsGroup {
	export const collection = 'reviews_group';
	export const api = `/api/${collection}`;

	const reviewsGroupIcons = {
		DEFAULT: 'default',
		VK: 'vk',
		ZOON: 'zoon',
		YANDEX: 'yandex',
		YELL: 'yell',
		TWOGIS: 'twogis',
		YOUTUBE: 'youtube',
	} as const;

	export type Model = Common.Model & {
		title: string;
		link: string;
		icon: (typeof reviewsGroupIcons)[keyof typeof reviewsGroupIcons];
	};

	export const modelState: Model = {
		...Common.modelState,
		title: '',
		link: '',
		icon: reviewsGroupIcons.DEFAULT,
	};
}
